<template>
  <div class="dashboard__list__header">
    <div class="checkbox__cell">
      <slot name="checkbox"></slot>
    </div>
    <div class="unit__cell header-cell">
      <div>{{ $t('dashboard.nav.unit') }}</div>
      <OrderSelector column="unit" :active="activeSort" @onChange="sortChange" />
    </div>
<!--      <div class="order__cell header-cell" v-responsive.sm.xs.md>-->
<!--          <div>{{ $t('dashboard.nav.favourite') }}</div>-->
<!--      </div>-->
    <div class="remark__cell header-cell" v-responsive.sm.xl.lg.md>
      <div>{{ $t('dashboard.nav.remark') }}</div>
      <OrderSelector column="remark" :active="activeSort" @onChange="sortChange" />
    </div>
    <div class="dynamic-section" v-responsive.xl v-if="showInEnv(env_tentacles)">
      <div v-for="sensor in sensors" :key="sensor.id" class="sensor__cell header-cell">
        <div>{{ $t('metrics.' + sensor.label) }}</div>
        <OrderSelector :column="sensor.label" :active="activeSort" @onChange="sortChange" />
      </div>
    </div>
    <div class="last-update__cell header-cell" v-responsive.xl.lg.md>
      <div>{{ $t('dashboard.nav.l_update') }}</div>
      <OrderSelector column="last-update" :active="activeSort" @onChange="sortChange" />
    </div>
    <div class="settings-sent__cell header-cell" v-responsive.xl.lg.md v-if="showInEnv(env_tentacles)">
      <div>{{ $t('dashboard.nav.frame_update') }}</div>
      <!--<OrderSelector column="settings-sent" :active="activeSort" @onChange="sortChange" />-->
    </div>
    <div class="dynamic-timing__cell header-cell" v-if="showTimSen" v-responsive.xl.lg>
      <div>{{ $t('dashboard.nav.timing') }}</div>
    </div>
    <div v-if="type.id === SOIL_3XS && showTimSen" class="dynamic-sensing__cell header-cell" v-responsive.xl.lg>
      <div>{{ $t('dashboard.nav.sensing') }}</div>
      <BaseHelpWidget title="Dynamic sensing" style="z-index: 6;">
        <p class="help__paragraph">
          Lorem ipsum dolor
          <span>sit amet</span>, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
        </p>
        <p class="help__paragraph">
          Lorem ipsum dolor sit amet,
          <span>consectetur</span> adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore
          <span>magna</span> aliqua.
        </p>
      </BaseHelpWidget>
    </div>
    <div class="lqi__cell header-cell" v-responsive.sm.xl.lg.md v-if="showInEnv(env_tentacles)">
      <div v-tooltip.top="$t('dashboard.nav.lqi_hover')">{{ $t('dashboard.nav.lqi') }}</div>
    </div>
    <div class="order__cell header-cell" v-if="showInEnv(env_tentacles)">
      <div>{{ $t('dashboard.nav.favourite') }}</div>
    </div>
    <div class="action__cell"></div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import OrderSelector from '@/components/OrderSelector.vue';

export default {
  name: 'DashboardListHeader',
  components: {
    OrderSelector,
  },
  data() {
    return {
      showTimSen: false,
      SOIL_3XS: 1,
      env_emeta: process.env.VUE_APP_ENV_EMETA,
      env_tentacles: process.env.VUE_APP_ENV_TENTACLES,
      env_etentacles: process.env.VUE_APP_ENV_ETENTACLES,
    };
  },
  props: {
    activeSort: {
      type: Object,
    },
    sensors: {
      type: Array,
      default: value => [1],
    },
  },
  computed: {
    ...mapGetters('tentacle', ['type']),
  },
  methods: {
    sortChange(sort) {
      this.$emit('onSortChange', sort);
    },
    showInEnv(type) {
      return process.env.VUE_APP_ENVIRONMENT === type;
    },
  },
};
</script>

<style lang="scss" scoped>
.header-cell {
  display: flex;
  align-items: center;
  color: $grey;
  font-size: 1.3rem;
  font-weight: 500;
}

.dashboard__list__header {
  height: 6rem;
  display: flex;
  align-items: stretch;
  border-bottom: 0.1rem solid $border-color;
}

.dynamic-section {
  flex-grow: 1;
  display: flex;
  align-items: stretch;
}

.checkbox__cell {
  padding-right: 1.5rem;
  width: 6.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
}

.unit__cell {
  width: 21.5rem;
    //margin-left: 1.5em;
}

.remark__cell {
  width: 16rem;
}

.lqi__cell {
  width: 7rem;
  word-break: break-word;
}

.sensor__cell {
  flex: 1;
}

.last-update__cell {
  width: 13rem;
  margin-left: auto;
}

.settings-sent__cell {
  width: 13rem;
  margin-left: auto;
}

.dynamic-timing__cell {
  width: 18rem;
  margin-left: auto;
}

.dynamic-sensing__cell {
  width: 20rem;
  margin-left: auto;
}

.notification__cell {
  width: 10rem;
  margin-left: auto;
}

.order__cell {
  width: 7rem;
  margin-left: 0.5rem;
    @media only screen and (max-width: 991px) {
        padding-left: 1em;
        width: 7.5em;
        margin-left: 0;
    }
}

.action__cell {
  width: 10rem;
  margin-left: auto;
}

.help__paragraph {
  font-weight: 400;
  font-size: 1.1rem;
  line-height: 1.5rem;

  span {
    color: $company-color;
  }
}
</style>
